import { useApprovalDrawerViewOptimizationFlag } from '@/hooks/feature_flag/useApprovalDrawerViewOptimizationFlag';
import { useState } from 'react';

export const TransactionsLayouts = {
  table: 'table',
  card: 'card',
} as const;

export type TransactionsLayout =
  (typeof TransactionsLayouts)[keyof typeof TransactionsLayouts];

const DEFAULT_LAYOUT: TransactionsLayout = TransactionsLayouts.table;

/**
 * Tracks the 支払明細 layout choice for the current drawer session only.
 * Per AC1 (NA-5528), table is always the layout when the drawer opens — the
 * choice is not persisted across drawer opens or users.
 *
 * Gated by the `approval-drawer-view-optimization` flag. The clamp lives here
 * rather than at the call site so a caller cannot forget it: with the flag off
 * the layout is always `table`, even if the user switched to `card` earlier in
 * the same session while the flag was on.
 */
export const useTransactionsLayout = () => {
  const isLayoutSwitchEnabled = useApprovalDrawerViewOptimizationFlag();

  const [layout, setLayout] = useState<TransactionsLayout>(DEFAULT_LAYOUT);

  return {
    layout: isLayoutSwitchEnabled ? layout : DEFAULT_LAYOUT,
    setLayout,
    isLayoutSwitchEnabled,
  };
};
